import { ChangePhoneComponent } from '../../../../forms/dynamic-forms/profile-settings-forms/change-phone/change-phone.component';
import { PhoneSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/phone-svg/phone-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { EditPhoneService } from '../../../../../_services/forms/profile-settings/edit-phone.service';
import { Component, OnInit } from '@angular/core';

import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, PhoneSvgComponent, ChangePhoneComponent],
  selector: 'app-profile-phone',
  templateUrl: './profile-phone.component.html',
  providers: [EditPhoneService],
})
export class ProfilePhoneComponent implements OnInit {
  accountPhoneForm: any[];
  whereInTheProcess: string;

  constructor(
    private editPhoneService: EditPhoneService,
    private activatedRoute: ActivatedRoute,
    private errorRedirectionService: ErrorRedirectionService
  ) {}

  ngOnInit() {
    this.editPhoneService.getInputs().subscribe(
      (eidtPhoneResponse) => {
        this.accountPhoneForm = eidtPhoneResponse;
      },
      (error) => {
        if (error.status) {
          this.errorRedirectionService.redirect(error.status);
        }
      }
    );
    this.whereInTheProcess = this.activatedRoute.snapshot.routeConfig.path;
  }
}
